import React from 'react'
import { IService } from '../../models/services'
import ServiceCard from './ServiceCard/ServiceCard'
import './ServicesComponent.scss'
import { ReactComponent as Web } from '../../assets/services/web-icon.svg'
import { ReactComponent as Mobile } from '../../assets/services/mobile-icon.svg'
import { ReactComponent as Bots } from '../../assets/services/bot-icon.svg'
import { ReactComponent as Projects } from '../../assets/services/projects-icon.svg'
import { ReactComponent as Support } from '../../assets/services/support-icon.svg'

interface ServicesComponentProps {
    
}

const ServicesComponent:React.FC<ServicesComponentProps> = ({}) => {
    const data: IService[] = [
        {
            title: 'Websites Development',
            features: ['Landing Page', 'Corporative sites', 'Online shop', 'Catalog site' ,'İnformation portal','İndividual solutions'],
            icon: <Web/>
        },
        {
            title: 'Mobile Development',
            features: ['Native apps', 'Cross-platform software', 'Creating gaming platforms'],
            icon: <Mobile/>
        },
        {
            title: 'Bots and Parsers Development',
            features: ['Telegram bots creating', 'Facebook bots creating', 'Whatsapp bots creating', 'Parsers development', 'Chat bots creating'],
            icon: <Bots/>
        },
        {
            title: 'Complicated internet projects',
            features: ['Audio and video solutions', 'Payment systems', 'SaaS services', 'High-Load projects', 'Social networks'],
            icon: <Projects/>
        },
        {
            title: 'Technical support',
            features: ['Websites support', 'API development', 'Integrations', 'IT support', 'Outsourcing'],
            icon: <Support/>
        },
    ]

    return (
        <div className='ServicesComponent container'>
            <div className="col-12 d-flex flex-wrap justify-content-center">
                {data.map(service => {
                    return (
                        <ServiceCard 
                            className='col-6 col-lg-4 px-3'
                            title={service.title}
                            icon={service.icon}
                            features={service.features}
                        />
                    )
                })}
            </div>
        </div>
    )
}

export default ServicesComponent